import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
  /* 
      Documentacion:
      https://material.angular.io/cdk/layout/overview
      https://material.io/design/layout/responsive-layout-grid.html#breakpoints
  */
  isHandsetMobile$: Observable<boolean> = this.breakpointObserver
    .observe('(max-width: 767px)')
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

  isHandsetTablet$: Observable<boolean> = this.breakpointObserver
    .observe('(max-width: 1023px)')
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );
  isHandsetSoloAdv$: Observable<boolean> = this.breakpointObserver
    .observe('(min-width: 768px)')
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );
  constructor(private breakpointObserver: BreakpointObserver) {}
}
